import { setAuthToken } from '@/lib/apollo-client'

const API_BASE = import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000'

/** Ask for anything that needs a real X account to sign in first. */
export function requestSignIn(reason?: string) {
  window.dispatchEvent(new CustomEvent('x11:sign-in-required', { detail: { reason } }))
}

/**
 * Opens the public demo: a short-lived guest account, no X login. The page
 * reloads into Create so every provider boots with the guest token.
 */
export async function startGuestSession(next = '/chat'): Promise<void> {
  const response = await fetch(`${API_BASE}/api/guest/session`, { method: 'POST', credentials: 'include' })
  const body = await response.json().catch(() => ({}))
  if (!response.ok || !body.token) {
    throw new Error(body.error || 'Could not open the demo right now.')
  }
  setAuthToken(body.token, body.refreshToken)
  window.location.assign(next)
}
